import * as Long from "long";
import { filter, ignoreElements, retry, switchMap } from "rxjs/operators";
import { selectBalancingPackageById } from "../../../balancingSelectors/selectBalancingPackages";
import { IdResource } from "../../../constants/IdResource";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionPackages } from "../actionPackages";
var notRedeemablePackageFilter = function (state$) { return function (action) {
    var packageCanBeRedeemed = false;
    if (action.type === TypeActionPackages.ConsumePackage) {
        var coopId = state$.value.playerInfo.coopId;
        var selectedPackage = selectBalancingPackageById(action.packageId);
        var packageHasCoopFundsInRewards = selectedPackage &&
            selectedPackage.resourceReward &&
            selectedPackage.resourceReward.find(function (element) { return element.resourceId === IdResource.CoopFunds; }) !== undefined;
        packageCanBeRedeemed = !((coopId === undefined || Long.ZERO.equals(coopId)) &&
            packageHasCoopFundsInRewards);
    }
    return packageCanBeRedeemed;
}; };
export var epicConsumePackage = function (action$, state$, deps) {
    return action$.pipe(filter(notRedeemablePackageFilter(state$)), switchMap(function (action) {
        var state = state$.value;
        var playerId = state.playerInfo.playerId;
        return deps
            .netSend({
            id: CommandCode.ConsumePackage,
            props: {
                amount: action.amount,
                packageId: action.packageId,
                playerId: playerId,
            },
        })
            .pipe(retry());
    }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/item-packages/epics/epicConsumePackage.ts
// module id = 1976
// module chunks = 3